import { createCRUDEndpoints } from '@/api/factory/crud';
import { createTranslateEndpoint } from '@/api/factory/translate';
import { PublicTreatmentJSON, PublicTreatmentStatus } from '@/store/modules/treatments/public-treatment';

type ListParams =
  | {
      title?: string;
      search?: string;
      status?: string | number | PublicTreatmentStatus;
      page?: string | number;
      sort?: string;
      direction?: 'asc' | 'desc';
    }
  | undefined;

export const translate = createTranslateEndpoint<PublicTreatmentJSON>({ slug: 'public_treatment' });

export const { list, get, store, remove, restore } = createCRUDEndpoints<PublicTreatmentJSON, ListParams>({
  slug: 'public_treatment',
});
